// extracted by mini-css-extract-plugin
module.exports = {"icon":"Preload_icon__2rDAo"};